import { useContext, useEffect } from "react";
import SelectedTeamContext from "../../contexts/SelectedTeamContext";
import FinalizedStatusContext from "../../contexts/FinalizedStatusContext";
import { formatRosterDate } from "../../utils/DateUtils";

export const useFinalizedStatus = tournamentType => {
  // context(s)
  const selectedTeamContext = useContext(SelectedTeamContext);
  const finalizedStatusContext = useContext(FinalizedStatusContext);

  const { dispatch } = finalizedStatusContext;

  useEffect(() => {
    const { finalizedStatus } = selectedTeamContext.state.team;
    const finalized = finalizedStatus && finalizedStatus[`${tournamentType}RosterFinalizedDate`] !== null;
    const finalizedTimestamp = finalizedStatus && finalizedStatus[`${tournamentType}RosterFinalizedDate`];
    const finalizedAt = finalizedTimestamp ? formatRosterDate(finalizedTimestamp) : null;
    dispatch({ type: "setFinalizedStatus", finalized });
    dispatch({ type: "setFinalizedAt", finalizedAt });
  }, [dispatch, tournamentType, selectedTeamContext.state.team]);
};
